const collectionTabsInit = () => {

  const initSlider = () => {
    var flkty = new Flickity('.collection-tabs .carousel', {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,

      freeScroll: false
    });
  }
  const tabClickEvent = () => {
    const items = document.querySelectorAll('.collection-tabs .ct-tab-trigger');
    items.forEach(item => {
      item.addEventListener("click", (e) => {
        tabClickEventAction(e);
      })
    })
  }
  const tabClickEventAction = e => {
    const parent = e.currentTarget.closest(".collection-tabs");
    const tabs = parent.querySelectorAll('.ct-tab-trigger');
    const productsContainer = parent.querySelector('.products');
    tabs.forEach(item => {
      item.classList.remove("active");
    })
    let minHeight = productsContainer.offsetHeight;
    productsContainer.style.minHeight = minHeight+"px";
    const tabsContent = parent.querySelectorAll(".single-collection");
    tabsContent.forEach(item => {
      item.classList.add("hide");
    })
    let targetContent = e.target.getAttribute("data-collection");
    targetContent = parent.querySelector(`.ct-${targetContent}`);
    if (!targetContent) {
      
      return;
    }
    targetContent.classList.remove("hide");
    e.target.classList.add('active');
    window.dispatchEvent(new Event('resize'));
    
  }
  // initSlider();
  tabClickEvent();
}
collectionTabsInit();